import { SORT_ORDER } from '.';
import { AuditEntity } from './AuditEntity';
import { FoodItem } from './FoodItem';
import { FoodType } from './FoodType';
import { Department } from './Store';
import { State } from './Timers';

export enum FoodTrayTemplateField {
  ID = 'id',
  NAME = 'name',
  DEPARTMENT = 'department',
  FOOD_TRAYS = 'foodTrays',
  CREATED_AT = 'createdAt',
  UPDATED_AT = 'updatedAt',
}

export interface FoodTrayTemplate extends AuditEntity {
  name: string;
  department: Department;
  foodLines: FoodLine[];
}

export interface FoodLine extends AuditEntity {
  index: number;
  name: string;
  foodTrays: FoodTray[];
}

export enum FoodTraySize {
  FULL = '1/1',
  HALF = '1/2',
  ONE_THIRD = '1/3',
  TWO_THIRDS = '2/3',
}

export const FOOD_TRAY_SIZES_PER_COLUMN = [
  [FoodTraySize.FULL],
  [FoodTraySize.HALF, FoodTraySize.HALF],
  [FoodTraySize.ONE_THIRD, FoodTraySize.TWO_THIRDS],
  [FoodTraySize.TWO_THIRDS, FoodTraySize.ONE_THIRD],
  [FoodTraySize.ONE_THIRD, FoodTraySize.ONE_THIRD, FoodTraySize.ONE_THIRD],
];

export interface FoodTray extends AuditEntity {
  columnIndex: number;
  rowIndex: number;
  size: FoodTraySize;
  defaultFoodType: FoodType | null;
  foodLine: FoodLine;
  foodItem: FoodItem;
}

export interface SelectedFoodTrayIndex {
  columnIndex: number;
  rowIndex: number;
}

export interface WarningItem {
  state: State;
  id: string;
}

export interface FetchFoodTrayTemplatesFilters {
  sort: string[];
  departmentId: string;
}

export const GET_TEMPLATE_SORT_OPTIONS = () => [
  {
    value: FoodTrayTemplateField.CREATED_AT,
    label: 'lblCreated',
    sortOrder: SORT_ORDER.DESC,
  },
  {
    value: FoodTrayTemplateField.NAME,
    label: 'lblName',
    sortOrder: SORT_ORDER.ASC,
  },
  {
    value: FoodTrayTemplateField.UPDATED_AT,
    label: 'lblUpdated',
    sortOrder: SORT_ORDER.DESC,
  },
];
